import {
  geminiPriorityColors,
  geminiStatusColors,
} from "../../../assets/theme/geminiPalette";
import {
  getIncidentPriorityLabel,
  INCIDENT_PRIORITIES,
  INCIDENT_PRIORITY_OPTIONS,
  normalizeIncidentPriority,
  toIncidentPriorityEnum,
} from "../../../lib/incident/priority";

export {
  getIncidentPriorityLabel,
  INCIDENT_PRIORITIES,
  INCIDENT_PRIORITY_OPTIONS,
  normalizeIncidentPriority,
  toIncidentPriorityEnum,
};

export type IncidentPriorityValue = (typeof INCIDENT_PRIORITIES)[number];

export type IncidentFolderId =
  | "inbox"
  | "group"
  | "all"
  | "anomalies"
  | "new"
  | "critical"
  | "resolved";

export const INCIDENT_FOLDERS: {
  id: IncidentFolderId;
  label: string;
  icon: string;
  description: string;
}[] = [
  { id: "inbox", label: "Inbox", icon: "inbox", description: "Assigned to you" },
  { id: "group", label: "My Group", icon: "groups", description: "Group queue" },
  { id: "all", label: "All Incidents", icon: "all_inbox", description: "Full list" },
  { id: "anomalies", label: "Anomalies", icon: "notifications_active", description: "With detected anomalies" },
  { id: "new", label: "New", icon: "fiber_new", description: "Status: New" },
  { id: "critical", label: "Critical", icon: "priority_high", description: "Critical priority" },
  { id: "resolved", label: "Resolved", icon: "task_alt", description: "Resolved or closed" },
];

export const PRIORITY_FILTER_OPTIONS = [
  { value: "all", label: "All Priorities", color: geminiPriorityColors.default, icon: "filter_list", i18nKey: "options.priority.all" },
  { value: "CRISIS", label: "Crisis", color: geminiPriorityColors.CRISIS, icon: "emergency", i18nKey: "options.priority.CRISIS" },
  { value: "CRITICAL", label: "Critical", color: geminiPriorityColors.CRITICAL, icon: "error", i18nKey: "options.priority.CRITICAL" },
  { value: "HIGH", label: "High", color: geminiPriorityColors.HIGH, icon: "priority_high", i18nKey: "options.priority.HIGH" },
  { value: "MEDIUM", label: "Medium", color: geminiPriorityColors.MEDIUM, icon: "remove", i18nKey: "options.priority.MEDIUM" },
  { value: "LOW", label: "Low", color: geminiPriorityColors.LOW, icon: "south", i18nKey: "options.priority.LOW" },
];

export const STATUS_FILTER_OPTIONS = [
  { value: "all", label: "All Status", color: geminiStatusColors.default, icon: "filter_list", i18nKey: "options.incidentStatus.all" },
  { value: "NEW", label: "New", color: geminiStatusColors.NEW, icon: "fiber_new", i18nKey: "options.incidentStatus.NEW" },
  { value: "ASSIGNED", label: "Assigned", color: geminiStatusColors.ASSIGNED, icon: "person_add", i18nKey: "options.incidentStatus.ASSIGNED" },
  { value: "IN_PROGRESS", label: "In Progress", color: geminiStatusColors.IN_PROGRESS, icon: "autorenew", i18nKey: "options.incidentStatus.IN_PROGRESS" },
  { value: "ON_HOLD", label: "On Hold", color: geminiStatusColors.ON_HOLD, icon: "pause_circle", i18nKey: "options.incidentStatus.ON_HOLD" },
  { value: "RESOLVED", label: "Resolved", color: geminiStatusColors.RESOLVED, icon: "task_alt", i18nKey: "options.incidentStatus.RESOLVED" },
  { value: "CLOSED", label: "Closed", color: geminiStatusColors.CLOSED, icon: "lock", i18nKey: "options.incidentStatus.CLOSED" },
  { value: "CANCELLED", label: "Cancelled", color: geminiStatusColors.CANCELLED, icon: "cancel", i18nKey: "options.incidentStatus.CANCELLED" },
];

export const SORT_OPTIONS = [
  { value: "createdDate", label: "Created Date", icon: "event", i18nKey: "options.sortField.createdDate" },
  { value: "detectedAt", label: "Detected At", icon: "sensors", i18nKey: "options.sortField.detectedAt" },
  { value: "title", label: "Title", icon: "title", i18nKey: "options.sortField.title" },
  { value: "priority", label: "Priority", icon: "flag", i18nKey: "options.sortField.priority" },
  { value: "status", label: "Status", icon: "info", i18nKey: "options.sortField.status" },
  { value: "assignedTo", label: "Assignee", icon: "person", i18nKey: "options.sortField.assignedTo" },
];

export const LIST_PAGE_SIZES = [25, 50, 100] as const;
